import React, { useState, useEffect } from "react";
import * as S from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import { SubmitButton } from "components/Buttons/SubmitButton";
import { CheckBoxOutlined } from "@mui/icons-material";
import CompDropdownMUI from "components/CompDropdownMUI";
import { Button, CircularProgress } from "@mui/material";
import SuccessAlert from "components/Alerts/SuccessAlert";
import FillErrorAlert from "components/Alerts/FillErrorAlert";
import { useNavigate } from "react-router-dom";

import * as u from "utils/constants";
const DeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  cancelError,
  cancelErrorDropdown,
  alertType,
  setAlertType,
  isLoading,
  benefitId,
}) => {
  const [justification, setJustification] = useState("");
  const [reason, setReason] = useState("");
  const navigate = useNavigate();

  const Feedback = () => <CircularProgress color="inherit" size="1.5rem" />;

  if (!isOpen) {
    return null;
  }

  const handleJustificationChange = (e) => {
    setJustification(e.target.value);
  };

  const handleConfirm = () => {
    onConfirm(justification, reason);
  };

  const ConfirmCancellationBeneficiary = ({
    onClick,
    alertType,
    setAlertType,
  }) => {
    return (
      <SubmitButton
        isLoading={isLoading}
        onClick={onClick}
        alertType={alertType}
        setAlertType={setAlertType}
        buttonText="Confirmar cancelamento"
        successMsg="Beneficiário cancelado com sucesso."
        errorMsg="Erro ao cancelar o beneficiário."
        startIcon={<CheckBoxOutlined />}
        reload
        sx={{ width: "260px" }}
      />
    );
  };

  function goToVisualization() {
    setAlertType("");

    navigate(`/beneficiarios/${benefitId}`);
    setTimeout(() => {
      window.location.href = `/beneficiarios/${benefitId}`;
    }, 100);
  }
  return (
    <S.ModalOverlay>
      <S.ModalContent>
        <S.CloseButton onClick={onClose}>
          <CloseIcon />
        </S.CloseButton>
        <S.ModalHeader>
          <S.ModalTitle>Cancelar Beneficiário</S.ModalTitle>
        </S.ModalHeader>
        <S.ModalBody style={{}}>
          <div style={{ marginBottom: "4%", width: "100%" }}>
            <CompDropdownMUI
              options={[
                ...u.irregularities,
                ...u.irregularitiesReasonsAdditional,
              ]}
              required={true}
              placeholder="Motivo do cancelamento"
              sx={{ width: "100%" }}
              value={reason}
              noController={true}
              onChange={(e) => setReason(e.target.value)}
            />
            {cancelErrorDropdown && (
              <S.ErrorMessage>{cancelErrorDropdown}</S.ErrorMessage>
            )}
          </div>

          <S.JustificationText>
            JUSTIFICATIVA PARA O CANCELAMENTO DESTE BENEFICIÁRIO
          </S.JustificationText>
          <S.TextAreaWrapper>
            <S.CustomTextArea
              placeholder="Justifique aqui o motivo do cancelamento do beneficiário"
              maxLength={200}
              value={justification}
              onChange={handleJustificationChange}
            />
          </S.TextAreaWrapper>
          {cancelError && <S.ErrorMessage>{cancelError}</S.ErrorMessage>}
          <S.CharLimit>Máximo de 200 caracteres</S.CharLimit>
        </S.ModalBody>
        <S.ModalFooter>
          <Button
            startIcon={<CheckBoxOutlined />}
            variant="contained"
            disabled={justification.length <= 0 || reason.length <= 0}
            endIcon={isLoading && <Feedback />}
            sx={{
              backgroundColor: "#88C54B",
              // width: "129px",
              // height: "54px",
              padding: "15px 16px",
              borderRadius: "8px",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 300,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#88C54B",
              },
              color: "#fff",
            }}
            onClick={handleConfirm}
          >
            Confirmar Cancelamento
          </Button>
          {/* <ConfirmCancellationBeneficiary
            onClick={handleConfirm}
            alertType={alertType}
            setAlertType={setAlertType}
          /> */}
        </S.ModalFooter>
      </S.ModalContent>
      <SuccessAlert
        open={alertType && alertType === "success"}
        onClose={goToVisualization}
        alertText={"Beneficiário cancelado com sucesso."}
      />

      <FillErrorAlert
        open={alertType && alertType === "error"}
        onClose={() => setAlertType("")}
      />
    </S.ModalOverlay>
  );
};

export default DeleteModal;
